/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ReviewNoteResponseDto,
  UpsertReviewNotePayloadDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReviewNoteResponseDtoFromJSON,
    ReviewNoteResponseDtoToJSON,
    UpsertReviewNotePayloadDtoFromJSON,
    UpsertReviewNotePayloadDtoToJSON,
} from '../models/index';

export interface GetReviewNoteBySubmissionIdRequest {
    submissionId: string;
}

export interface UpsertReviewNoteBySubmissionIdRequest {
    submissionId: string;
    upsertReviewNotePayloadDto: UpsertReviewNotePayloadDto;
}

/**
 * 
 */
export class ReviewNoteApi extends runtime.BaseAPI {

    /**
     * Get review note by submission ID
     */
    async getReviewNoteBySubmissionIdRaw(requestParameters: GetReviewNoteBySubmissionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReviewNoteResponseDto>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getReviewNoteBySubmissionId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/review-note/{submissionId}`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReviewNoteResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get review note by submission ID
     */
    async getReviewNoteBySubmissionId(requestParameters: GetReviewNoteBySubmissionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReviewNoteResponseDto> {
        const response = await this.getReviewNoteBySubmissionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert review note by submission ID
     */
    async upsertReviewNoteBySubmissionIdRaw(requestParameters: UpsertReviewNoteBySubmissionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReviewNoteResponseDto>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling upsertReviewNoteBySubmissionId().'
            );
        }

        if (requestParameters['upsertReviewNotePayloadDto'] == null) {
            throw new runtime.RequiredError(
                'upsertReviewNotePayloadDto',
                'Required parameter "upsertReviewNotePayloadDto" was null or undefined when calling upsertReviewNoteBySubmissionId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/review-note/{submissionId}`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertReviewNotePayloadDtoToJSON(requestParameters['upsertReviewNotePayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReviewNoteResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upsert review note by submission ID
     */
    async upsertReviewNoteBySubmissionId(requestParameters: UpsertReviewNoteBySubmissionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReviewNoteResponseDto> {
        const response = await this.upsertReviewNoteBySubmissionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
